<template>
    <BaseDialog
        width="narrow"
        :show-close="false"
        :open="open"
        :title="title"
        :description="body"
        :disable-close-on-backdrop-click="isLoading"
        :return-focus-to="returnFocusTo"
        mobile-height="expanded"
        @update:open="updateOpen">
        <BaseNotification v-if="errorText" theme="error" :text="errorText" hide-dismiss />
        <p v-if="body" class="body-small text-ink-muted">{{ body }}</p>
        <template #footer>
            <BaseButton theme="neutral" size="sm" :disabled="isLoading" @click="updateOpen(false)"> {{ t("common.cancel") }} </BaseButton>
            <BaseButton theme="primary" size="sm" :disabled="isLoading" :aria-busy="isLoading" @click="emit('confirmed')">
                <i v-if="isLoading" class="bi bi-arrow-clockwise animate-spin" aria-hidden="true"></i>
                {{ confirmText ?? t("common.confirm") }}
            </BaseButton>
        </template>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import BaseNotification from "~vue/components/BaseNotification.vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
    open: boolean;
    title: string;
    body?: string;
    confirmText?: string;
    isLoading?: boolean;
    errorText?: string;
    returnFocusTo?: HTMLElement | null;
}>();

const { t } = useI18n();

const emit = defineEmits<{
    "update:open": [value: boolean];
    confirmed: [];
}>();

function updateOpen(value: boolean) {
    if (!props.isLoading) {
        emit("update:open", value);
    }
}
</script>
